import React, { FunctionComponent, memo, ReactElement, useCallback } from 'react'
import { ThemeProps, withTheme } from 'styled-components'
import { BaseImageProps } from './ImageTypes'
import StyledImage from './Styled'

const getAspectedValueFromString = (value: string, aspectRatio: number): string => {
    if (value.endsWith('%')) return '100%'
    return `calc(${value} / ${aspectRatio})`
}

export const Image: FunctionComponent<BaseImageProps & ThemeProps<object>> = ({
    src,
    height,
    width,
    testID,
    aspectRatio,
    ...rest
}): ReactElement => {
    const computeAspectValue = useCallback(
        (
            value?: number | string | number[] | string[],
            aspectRatio?: number
        ): number | string | number[] | string[] => {
            let newValue: number | string | number[] | string[] = '100%'
            if (value && !!aspectRatio) {
                if (typeof value === 'number') {
                    newValue = value / aspectRatio
                } else if (typeof value === 'string') {
                    newValue = getAspectedValueFromString(value, aspectRatio)
                } else if (value.some((value: number | string) => typeof value === 'number')) {
                    newValue = (value as number[]).map((v: number) => v / aspectRatio)
                } else {
                    newValue = (value as string[]).map((v: string) =>
                        getAspectedValueFromString(v, aspectRatio)
                    )
                }
            }
            return newValue
        },
        []
    )

    return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <StyledImage
            decoding="async"
            loading="lazy"
            src={src}
            height={!height ? computeAspectValue(width, aspectRatio) : height}
            width={
                !width
                    ? computeAspectValue(height, aspectRatio ? 1 / aspectRatio : undefined)
                    : width
            }
            data-testid={testID}
            {...rest}
        />
    )
}

export default withTheme(memo(Image))
